<template>
  <div class="appStore">
    <h3>应用市场</h3>
    <el-card class="card1" shadow="never">
      <ul>
        <li>
          <img
            style="width: 49px; height: 54px; display: block; margin: 35px auto"
            src="../../assets/images/ticons/Slice 15@2x.png"
            alt=""
          />
          <p class="p1">定制开发</p>
          <p class="p2">
            积木科技定位企业数字化服务， 为企业提供数字化中台与应用定制
          </p>
          <el-button type="primary" round @click="btn1">联系增长顾问</el-button>
        </li>
        <li>
          <img
            style="width: 49px; height: 54px; display: block; margin: 35px auto"
            src="../../assets/images/ticons/Slice 16@2x (1).png"
            alt=""
          />
          <p class="p1">企微私域系统</p>
          <p class="p2">
            积木云客为积木科技旗下基于 企业微信的一站式私域客户价值管理系统
          </p>
          <el-button type="primary" round @click="btn2">体验私域系统</el-button>
        </li>
      </ul>
    </el-card>
    <!-- 弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible">
      <el-form ref="myform" :rules="rules" :model="form">
        <el-form-item
          label="客户姓名"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            placeholder="请输入您的姓名"
            v-model="form.name1"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机号码"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            placeholder="输入您的手机号码"
            v-model="form.name2"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="type == 1"
          label="产品类型"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-select v-model="select" placeholder="选择您的产品类型">
            <el-option label="APP开发" value="1"></el-option>
            <el-option label="小程序开发" value="2"></el-option>
            <el-option label="微信开发" value="3"></el-option>
            <el-option label="网站开发" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="type == 1"
          label="预算金额"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            placeholder="请输入您的项目预算金额"
            v-model="form.name4"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="type == 1"
          label="工单类型描述"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            type="textarea"
            resize="none"
            placeholder="请输入10-500字工单类型描述"
            v-model="form.name5"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="type == 2"
          label="公司名称"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            placeholder="请输入您的公司名称"
            v-model="form.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="cancel">取 消</el-button>
        <el-button round type="primary" @click="yes"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      select: "",
      dialogFormVisible: false,
      type: "",
      title: "联系增长顾问",
      form: {
        name1: "",
        name2: "",
        name4: "",
        name5: "",
      },
      formLabelWidth: "120px",
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
      },
    };
  },
  methods: {
    //点击确定
    yes(){
      this.dialogFormVisible = false;
      this.$refs.myform.resetFields();
        this.$message({
          message: '提交成功',
          type: 'success'
        });
    },
    //点击取消
    cancel() {
      this.form = {
        name1: "",
        name2: "",
        name4: "",
        name5: "",
      };
      this.dialogFormVisible = false;
      this.$refs.myform.resetFields();
    },
    btn1() {
      this.title = "联系增长顾问";
      this.type = 1;
      this.dialogFormVisible = true;
    },
    btn2() {
      this.title = "预约演示申请";
      this.type = 2;
      this.dialogFormVisible = true;
    },
  },
};
</script>

<style lang='less'>
.appStore {
  padding: 20px;
  h3 {
    margin-top: 8px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .card1 {
    margin-top: 30px;
    height: 590px;
    ul {
      display: flex;
      li {
        position: relative;
        box-sizing: border-box;
        width: 246px;
        height: 289px;
        background: rgba(50, 126, 255, 0.07999999821186066);
        border-radius: 6px 6px 6px 6px;
        margin-left: 20px;
        padding: 0 18px;
        .p1 {
          font-size: 16px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          text-align: center;
        }
        .p2 {
          margin-top: 11px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          text-align: center;
        }
        .el-button {
          display: block;
          width: 172px;
          height: 40px;
          background: #327eff;
          position: absolute;
          left: 50%;
          margin-left: -86px;
          bottom: 25px;
        }
        &:nth-child(1) {
          margin-left: 0;
        }
      }
    }
  }
  .el-form {
    margin-top: 30px;
    .el-form-item__label {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .el-input__inner {
      width: 424px;
      height: 32px;
      background: #f6f6f6;
      border-radius: 16px;
    }
    .el-textarea__inner {
      width: 424px;
      height: 169px;
      background: #f6f6f6;
      border-radius: 5px;
    }
  }
  .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.09);
  }
}
</style>